import { createContext, useContext, useState, useCallback, useEffect } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [], total: 0 });

  const refresh = useCallback(async () => {
    if (!user || user.role !== "student") { setCart({ items: [], total: 0 }); return; }
    try { const { data } = await api.get("/cart"); setCart(data); } catch {}
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const add = async (courseId) => {
    const { data } = await api.post("/cart", { course_id: courseId });
    setCart(data);
    return data;
  };
  const remove = async (courseId) => {
    const { data } = await api.delete(`/cart/${courseId}`);
    setCart(data);
  };

  return (
    <CartContext.Provider value={{ cart, refresh, add, remove, count: cart.items.length }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
